export class VtsEvent {
    public logTime: Date = null;
    public eventTime: Date = null;
}
